
import jobLogo from '../images/Logo.svg'; 

// and keep the rest as is
// import littlemillennium from '../images/little-millennium.jpg';
import NPS from '../images/NPS.png';
import RIS from '../images/RIS.png';
import BW from '../images/BW.png';
import EIS from '../images/EIS.png';
import WhatsaApp from '../images/WhatsApp.svg';
import Teachersearch from '../images/Logo.svg';
import Edutel from "../assets/clients/Edutel.png";
import Global from "../assets/clients/Global.png";
import JGI from "../assets/clients/JGI.png";
// import LittleMillanium from "../assets/clients/little millanium.png";
import MountLitera from "../assets/clients/Mount litera.png";
import Sankalp from "../assets/clients/Sankalp.png";
import Sanmarga from "../assets/clients/Sanmarga.png";
import Shrikaraa from "../assets/clients/Shrikaraa.png";
import SLV from "../assets/clients/SLV.png";
import Takshila from "../assets/clients/Takshila.png";
import Varada from "../assets/clients/Varada.png";
import VidyaSoudha from "../assets/clients/Vidya soudha.png";
// eslint-disable-next-line import/no-anonymous-default-export
export default { jobLogo ,NPS,RIS,BW,EIS,WhatsaApp,Teachersearch, Edutel,
  Global,
  JGI,
//   LittleMillanium,
  MountLitera,
  Sankalp,
  Sanmarga,
  Shrikaraa,
  SLV,
  Takshila,
  Varada,
  VidyaSoudha };
